import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { StylesProvider } from '@mui/styles'
import { StyledEngineProvider } from '@mui/material/styles'
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router'

import store from 'redux/store'

import customJss from '@/themes/customJss'

import AllRoutes from './allRoutes'
import { DndProvider } from 'react-dnd'
import SignatureContextProvider from './modules/signature/_helpers/SignatureContext'
import { CollaborationContextProvider } from './modules/document/_helpers/CollaborationContext'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { IUserModel } from './modules/account/model/UserModelType'
import { WebSocketProvider } from './modules/webSocket'
import App from './App'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import AppThemeProvider from './app-theme-provider'

type Props = {
  user: IUserModel
}

const allRoutesArray = createRoutesFromElements(AllRoutes)

const RootComponent = (props: Props) => {
  const { user } = props

  useEffect(() => {
    const loader = document.querySelector('.loader')
    loader?.parentNode?.removeChild(loader)
  }, [])

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <StylesProvider jss={customJss}>
            <AppThemeProvider user={user}>
              <DndProvider backend={HTML5Backend} context={window}>
                <WebSocketProvider>
                  <SignatureContextProvider>
                    <CollaborationContextProvider>
                      <RouterProvider router={createBrowserRouter([{
                        Component: () => (
                          <App user={user} />
                        ),
                        children: allRoutesArray,
                      }])} />
                    </CollaborationContextProvider>
                  </SignatureContextProvider>
                </WebSocketProvider>
              </DndProvider>
            </AppThemeProvider>
          </StylesProvider>
        </StyledEngineProvider>
      </Provider>
    </LocalizationProvider>
  )
}

export default RootComponent
